'use client';

import Image from 'next/image';
import styles from './index.module.less';

export default function Step2() {
  return (
    <div className={styles.container}>
      <Image
        className={styles.image}
        src="/images/image-search/image-search-step2.gif"
        alt="image-search-step2"
        width={208}
        height={208}
        unoptimized
      />
    </div>
  );
}
